<template>
  <div class="device-list-loader-content-wrapper">
    <v-expansion-panels
      flat
      multiple
      readonly
      disabled
    >
      <v-expansion-panel
        v-for="i in getNavigationConfiguration.devicesPerPage"
        :key="`device-list-loader-item-${i + 1}`"
        class="device-list-loader-item-expansion-wrapper"
      >
        <Loaders type="checkbox" />
        <div class="device-list-loader-item-wrapper device-activity-details">
          <div class="flex-wrapper">
            <Loaders type="checkbox" />
            <Loaders type="label" />
          </div>
          <div class="flex-wrapper">
            <Loaders type="deviceActivity" />
            <div class="loader-separator" />
            <Loaders type="expansionButton" />
          </div>
        </div>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Loaders from '@/components/common/Loaders/Loaders.vue';
import { INavigation,
  store } from '@/store/modules/devices/types';

import './styles/devices-list-loader.scss';

@Component({
  components: {
    Loaders
  }
})
export default class DevicesListLoader extends Vue {
  @store.Getter
  private getNavigationConfiguration!: INavigation;
}
</script>
